const responsiveTables = () => {
  const tables = [].slice.call(document.getElementsByTagName("table"));

  tables.forEach(t => {
    const parent = t.parentNode;
    const wrap = document.createElement("div");
    wrap.style.overflowX = "auto";

    parent.insertBefore(wrap, t);
    wrap.appendChild(t);
  });
};

export default responsiveTables;
